export default {
  width: 12,
  offset: 0
}
